import axios from "axios";

const API = process.env.REACT_APP_API_URL;

export const getExistence = async (params) => {
	const { data } = await axios.get(`${API}/client/existence`, {
		params,
	});
	return data;
};
